export const ALLOWED_ROLES = [
  'Admin manager',
  'Project Coordinator',
  'Project Coordinator+'
]
